import basicClassCreator from '../utils/basicClassCreator';

export Dialog from './Dialog';
export DialogTitle from './DialogTitle';
export const DialogContent = basicClassCreator('DialogContent', 'mdl-dialog__content');
export DialogActions from './DialogActions';



/** WEBPACK FOOTER **
 ** ./src/Dialog/index.js
 **/